const clients = {
  en: {
    'clients.title': 'Clients',
    'clients.subtitle': 'Manage your client relationships',
    'clients.newClient': 'New Client',
    'clients.addClient': 'Add Client',
    'clients.updateClient': 'Update Client',
    'clients.cancel': 'Cancel',
    'clients.searchPlaceholder': 'Search clients...',
    'clients.loadFailed': 'Failed to load clients',
    'clients.confirmDelete':
      'Are you sure you want to delete this client? This will also delete all associated projects and time entries.',

    'clients.stats.projects': 'Projects',
    'clients.stats.activeProjects': 'Active Projects',

    'clients.added': 'Added',
    'clients.empty.title': 'No clients found',
    'clients.empty.description': 'Get started by adding your first client.',

    'clients.toast.created': 'Client created successfully',
    'clients.toast.createFailed': 'Failed to create client',
    'clients.toast.updated': 'Client updated successfully',
    'clients.toast.updateFailed': 'Failed to update client',
    'clients.toast.deleted': 'Client deleted successfully',
    'clients.toast.deleteFailed': 'Failed to delete client',

    'clients.addModalTitle': 'Add New Client',
    'clients.editModalTitle': 'Edit Client',

    'clients.form.clientName': 'Client Name',
    'clients.form.clientNameRequired': 'Client name is required',
    'clients.form.email': 'Email',
    'clients.form.emailInvalid': 'Please enter a valid email address',
    'clients.form.phone': 'Phone',
    'clients.form.company': 'Company',
    'clients.form.hourlyRate': 'Hourly Rate',
    'clients.form.hourlyRateRequired': 'Hourly rate is required',
    'clients.form.hourlyRatePlaceholder': 'e.g. 75.00',
    'clients.form.address': 'Address',
    'clients.form.notes': 'Notes',
    'clients.form.notesPlaceholder': 'Any additional notes about this client...',

    'clients.detail.loadFailed': 'Failed to load client details',
    'clients.detail.editClient': 'Edit Client',
    'clients.detail.contactInfo': 'Contact Information',
    'clients.detail.totalProjects': 'Total Projects',
    'clients.detail.totalHours': 'Total Hours',
    'clients.detail.totalRevenue': 'Total Revenue',
    'clients.detail.notes': 'Notes',

    'clients.detail.tabOverview': 'Overview',
    'clients.detail.tabProjects': 'Projects',
    'clients.detail.tabTimeEntries': 'Time Entries',
    'clients.detail.tabInvoices': 'Invoices',

    'clients.detail.activeProjects': 'Active Projects',
    'clients.detail.thisMonth': 'This Month',
    'clients.detail.avgProjectValue': 'Avg. Project Value',
    'clients.detail.recentActivity': 'Recent Activity',
    'clients.detail.noRecentActivity': 'No recent activity',
    'clients.detail.rateLabel': 'Rate',
    'clients.detail.perHour': '/hr',
    'clients.detail.dueLabel': 'Due',
    'clients.detail.logged': 'logged',
    'clients.detail.noProjects': 'No projects yet',
    'clients.detail.noTimeEntries': 'No time entries yet',
    'clients.detail.invoice': 'Invoice',
    'clients.detail.noInvoices': 'No invoices yet',

    'clients.table.date': 'Date',
    'clients.table.project': 'Project',
    'clients.table.task': 'Task',
    'clients.table.duration': 'Duration',
    'clients.table.user': 'User',
  },

  es: {
    'clients.title': 'Clientes',
    'clients.subtitle': 'Administra tus relaciones con los clientes',
    'clients.newClient': 'Nuevo cliente',
    'clients.addClient': 'Agregar cliente',
    'clients.updateClient': 'Actualizar cliente',
    'clients.cancel': 'Cancelar',
    'clients.searchPlaceholder': 'Buscar clientes...',
    'clients.loadFailed': 'No se pudieron cargar los clientes',
    'clients.confirmDelete':
      '¿Seguro que deseas eliminar este cliente? Esto también eliminará todos los proyectos y entradas de tiempo asociados.',

    'clients.stats.projects': 'Proyectos',
    'clients.stats.activeProjects': 'Proyectos activos',

    'clients.added': 'Agregado',
    'clients.empty.title': 'No se encontraron clientes',
    'clients.empty.description': 'Comienza agregando tu primer cliente.',

    'clients.toast.created': 'Cliente creado correctamente',
    'clients.toast.createFailed': 'No se pudo crear el cliente',
    'clients.toast.updated': 'Cliente actualizado correctamente',
    'clients.toast.updateFailed': 'No se pudo actualizar el cliente',
    'clients.toast.deleted': 'Cliente eliminado correctamente',
    'clients.toast.deleteFailed': 'No se pudo eliminar el cliente',

    'clients.addModalTitle': 'Agregar nuevo cliente',
    'clients.editModalTitle': 'Editar cliente',

    'clients.form.clientName': 'Nombre del cliente',
    'clients.form.clientNameRequired': 'El nombre del cliente es obligatorio',
    'clients.form.email': 'Correo electrónico',
    'clients.form.emailInvalid': 'Ingresa una dirección de correo electrónico válida',
    'clients.form.phone': 'Teléfono',
    'clients.form.company': 'Empresa',
    'clients.form.hourlyRate': 'Tarifa por hora',
    'clients.form.hourlyRateRequired': 'La tarifa por hora es obligatoria',
    'clients.form.hourlyRatePlaceholder': 'p. ej. 75.00',
    'clients.form.address': 'Dirección',
    'clients.form.notes': 'Notas',
    'clients.form.notesPlaceholder': 'Notas adicionales sobre este cliente...',

    'clients.detail.loadFailed': 'No se pudieron cargar los detalles del cliente',
    'clients.detail.editClient': 'Editar cliente',
    'clients.detail.contactInfo': 'Información de contacto',
    'clients.detail.totalProjects': 'Proyectos totales',
    'clients.detail.totalHours': 'Horas totales',
    'clients.detail.totalRevenue': 'Ingresos totales',
    'clients.detail.notes': 'Notas',

    'clients.detail.tabOverview': 'Resumen',
    'clients.detail.tabProjects': 'Proyectos',
    'clients.detail.tabTimeEntries': 'Entradas de tiempo',
    'clients.detail.tabInvoices': 'Facturas',

    'clients.detail.activeProjects': 'Proyectos activos',
    'clients.detail.thisMonth': 'Este mes',
    'clients.detail.avgProjectValue': 'Valor promedio del proyecto',
    'clients.detail.recentActivity': 'Actividad reciente',
    'clients.detail.noRecentActivity': 'Sin actividad reciente',
    'clients.detail.rateLabel': 'Tarifa',
    'clients.detail.perHour': '/h',
    'clients.detail.dueLabel': 'Vence',
    'clients.detail.logged': 'registrado',
    'clients.detail.noProjects': 'Aún no hay proyectos',
    'clients.detail.noTimeEntries': 'Aún no hay entradas de tiempo',
    'clients.detail.invoice': 'Factura',
    'clients.detail.noInvoices': 'Aún no hay facturas',

    'clients.table.date': 'Fecha',
    'clients.table.project': 'Proyecto',
    'clients.table.task': 'Tarea',
    'clients.table.duration': 'Duración',
    'clients.table.user': 'Usuario',
  },
};

export default clients;
